
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/institution/[slug]",
      function () {
        return require("private-next-pages/institution/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/institution/[slug]"])
      });
    }
  